<template>
  <div id="ProjBidNewPreview">
    <ProjBidNewHeader />
    <div class="panel-box">
      <ProjectViewSummary :project="project" />
      <router-link class="header_link" :to="{path:'/projbid/new/info/'+projectId}">
        <el-button class="eb-button-red eb-button-small">点击修改</el-button>
      </router-link>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <ProjBidViewNewProcurementMethod :project="project" />
      <router-link class="header_link" :to="{path:'/projbid/new/info/'+projectId}">
        <el-button class="eb-button-red eb-button-small">点击修改</el-button>
      </router-link>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <ProjectViewInvitesupplier v-if="project['buyScope']&&project.buyScope!='1'" :project="project" />
      <ProjectViewInvitesupplierList @onSupplierListCreated="onSupplierListCreated" v-if="project['buyScope']&&project.buyScope=='1'"
        :project="project" :previewSupplier="previewSupplier" />
      <router-link class="header_link" :to="{path:'/projbid/new/invitesupplier/'+projectId}">
        <el-button class="eb-button-red eb-button-small">点击修改</el-button>
      </router-link>
    </div>
    <div class="eb-line"></div>
    <ProjRuleViewList :ruleList="ruleList" :basePanelIndex="2">
      <template >
        <router-link class="header_link" :to="{path:'/projbid/new/ruleedit/'+projectId}">
          <el-button class="eb-button-red eb-button-small">点击修改</el-button>
        </router-link>
      </template>
    </ProjRuleViewList>
    <div class="panel-box">
      <ProjectViewHandsontable :title="projectHandsontableTitle" :hotSettings="shoppingListHotSettings" />
      <router-link class="header_link" :to="{path:'/projbid/new/purchaselist/'+projectId}">
        <el-button class="eb-button-red eb-button-small">点击修改</el-button>
      </router-link>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <ProjectViewPreText :title="projectViewCommentTitle" :content="project['projectComment']" />
      <router-link class="header_link" :to="{path:'/projbid/new/purchaselist/'+projectId}">
        <el-button class="eb-button-red eb-button-small">点击修改</el-button>
      </router-link>
    </div>
    <div class="eb-line"></div>
    <div class="eb-button-group">
      <router-link class="eb-button-group-btn" :to="{path:'/projbid/new/invitesupplier/'+projectId}">
        <el-button class="eb-button-orange eb-button-big">&lt; 选择供应商</el-button>
      </router-link>
      <el-button :loading="buttonLoading" @click="releaseProject" class="eb-button-group-btn eb-button-orange eb-button-big">发布项目 &gt;</el-button>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import BreakCrumb from '@/plugins/break-crumb';
import ProjBidNewHeader from '@/components/project/bid/new/ProjBidNewHeader';
import ProjectViewSummary from '@/components/project/common/ProjectViewSummary';
import ProjBidViewNewProcurementMethod from '@/components/project/bid/new/ProjBidViewNewProcurementMethod';
import ProjectViewInvitesupplier from '@/components/project/common/ProjectViewInvitesupplier';
import ProjectViewInvitesupplierList from '@/components/project/common/ProjectViewInvitesupplierList';
import ProjectViewHandsontable from '@/components/project/common/ProjectViewHandsontable';
import ProjectViewPreText from '@/components/project/common/ProjectViewPreText';
import ProjRuleViewList from '@/components/project/common/ruleview/ProjRuleViewList';
import { getProjectById, editProject } from '@/services/proj/bid-project-service';
import { listShop } from '@/services/proj/bid-shopping-list-service';
import { previewSupplier } from '@/services/proj/bid-supplier-list-service';
import { listRule } from '@/services/proj/bid-rule-service';
import { handleProjViewRuleList } from '@/services/proj/project-service';
export default {
  name: 'ProjBidNewPreview',
  components: {
    ProjBidNewHeader,
    ProjectViewSummary,
    ProjBidViewNewProcurementMethod,
    ProjectViewInvitesupplier,
    ProjectViewInvitesupplierList,
    ProjectViewHandsontable,
    ProjectViewPreText,
    ProjRuleViewList
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      user: this.$store.state.user.userInfo,
      buttonLoading: false,
      project: {
        projectCommentTitle: ''
      },
      projectViewCommentTitle: {
        number: '',
        text: '报价表备注'
      },
      projectHandsontableTitle: {
        number: '',
        text: '分项报价表'
      },
      previewSupplier: {},
      ruleList: [],
      shoppingListHotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['名称', '描述', '单位', '数量', '单价(投标方填写)', '总价'],
        renderAllRows: true,
        fillHandle: false,
        rowHeaderWidth: 40,
        data: [],
        columns: [
          {
            data: 'productName',
            type: 'text',
            width: 200,
            readOnly: true
          },

          {
            data: 'productDesc',
            type: 'text',
            width: 359,
            readOnly: true
          },
          {
            data: 'productUnit',
            type: 'text',
            width: 60,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'productNum',
            width: 75,
            className: 'htRight',
            readOnly: true,
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric'
          },
          {
            data: 'shoppingPrice',
            width: 120,
            className: 'htRight',
            type: 'numeric',
            readOnly: true,
            numericFormat: {
              pattern: '0,0.00'
            }
          },
          {
            data: 'shoppingSubtotal',
            width: 147,
            className: 'htRight',
            type: 'numeric',
            readOnly: true,
            numericFormat: {
              pattern: '0,0.00'
            }
          }
        ]
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let [{ data: data1 }, { data: data2 }, { data: data3 }] = await Promise.all([
          getProjectById({ projectId: this.projectId }),
          listShop(this.projectId),
          listRule({ projectId: this.projectId })
        ]);
        if (data1.returnCode === '01') {
          this.project = data1.project;
        } else {
          this.$message.error('获取项目信息失败');
        }
        if (data2.returnCode === '01' || data2.returnCode === '00') {
          if (data2.shopList) {
            this.shoppingListHotSettings.data = data2.shopList;
          }
        } else {
          this.$message.error('获取分项报价表信息失败');
        }
        if (data3.returnCode === '01') {
          this.ruleList = handleProjViewRuleList(data3.ruleList);
        } else {
          this.$message.error('加载规则模板规则列表失败');
        }
        this.changeTitleNumber(parseInt(this.ruleList.length) + 2);
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    changeTitleNumber: function(number) {
      this.projectHandsontableTitle.number = number + 1;
      this.projectViewCommentTitle.number = number + 2;
    },
    async onSupplierListCreated() {
      try {
        let { data } = await previewSupplier({ number: 10, page: 1, projectId: this.projectId });
        if (data.returnCode === '01') {
          this.previewSupplier = data;
        } else {
          this.$message.error('查询供应商列表失败');
        }
      } catch (error) {
        this.$message.error('查询供应商列表失败');
      }
    },
    async releaseProject() {
      this.$ebConfirm('确认发布项目吗?')
        .then(() => {
          this.editProjectService();
        })
        .catch(() => {});
    },
    async editProjectService() {
      this.buttonLoading = true;
      let params = {
        startTime: this.$options.filters['dateTimeStandardFormat'](new Date()),
        projectStatus: 2,
        projectId: this.projectId,
        updateId: this.user.userid
      };
      if (this.project.startType === 2 || this.project.startType === '2') {
        params.projectStatus = 2;
        delete params.startTime;
        if (this.project.startTime < parseInt(this.$options.filters['dateTimeUnixFormat']())) {
          this.$message.error('项目开始时间必须大于当前时间');
          this.buttonLoading = false;
          return;
        }
      } else {
        this.project.startTime = parseInt(moment(params.startTime).format('x'));
        params.projectStatus = 3;
      }
      if (this.project.startTime > this.project.endTime) {
        this.$message.error('项目截止时间必须大于开始时间');
        this.buttonLoading = false;
        return;
      }
      try {
        let { data } = await editProject(params);
        this.buttonLoading = false;
        if (data.returnCode === '01' || data.returnCode === '00') {
          var breakCrumb = new BreakCrumb();
          breakCrumb.clearItem();
          breakCrumb.setBreakCrumb('招标项目', '/projbid/list');
          this.$router.push({ path: '/projbid/list' });
        } else {
          this.$message.error('保存失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.panel-box {
  position: relative;
  .header_link {
    position: absolute;
    right: 20px;
    top: 46px;
  }
}
</style>
